export const NavItems = [
	{
		title: "Home",
		url: "/home",
		cName: "nav_links",
	},
	{
		title: "Menu",
		url: "/menu",
		cName: "nav_links",
	},
];
